import React, { useState } from 'react';
import { Grid, Button, Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import Delights from './Delights';
import DelightsForm from '../DelightsApplication/DelightsForm';

const DelightsApplication = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Grid
        container
        sx={{
          justifyContent: isSmallScreen ? 'center' : 'space-between',
          // height: 'calc(100vh - 135px)',
          height: '100%',
        }}
      >
        <Grid
          item
          xl={8.6}
          sx={{
            backgroundColor: 'white',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
          }}
        >
          <Delights />
        </Grid>

        {!isSmallScreen && (
          <Grid
            item
            xl={3.3}
            sx={{
              p: 2,
              backgroundColor: 'white',
              borderRadius: '10px',
              border: 1,
              borderColor: 'divider',
            
            }}
          >
            <DelightsForm />
          </Grid>
        )}
      </Grid>
      {/* <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth maxWidth="lg">
          <DialogContent>
            <Delights />
          </DialogContent>
        </Dialog>
        {isSmallScreen && (
          <Grid sm={12}>

          <Button variant="outlined" size="small" fullWidth onClick={handleDialogOpen} sx={{height:'2rem'}}>
            Previous Applications
          </Button>
          </Grid>
        )} */}
    </>
  );
};

export default DelightsApplication;
